<template>
  <svg @mouseover="mouse = true" @mouseleave="mouse = false" @click="pressed = true; copy()" :width="32" :height="32" viewBox="..." fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle v-if="mouse" :cx="circleCx" :cy="circleCy" :r="circleR" :fill="cicleHoverFill"/>
    <circle v-if="pressed" cx="16" :cy="circleCy" :r="circleR" :fill="ciclePressedFill"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9 14.7998C9 13.281 10.2312 12.0498 11.75 12.0498H16.75C18.2688 12.0498 19.5 13.281 19.5 14.7998V19.7998C19.5 21.3186 18.2688 22.5498 16.75 22.5498H11.75C10.2312 22.5498 9 21.3186 9 19.7998V14.7998ZM11.75 13.5498C11.0596 13.5498 10.5 14.1094 10.5 14.7998V19.7998C10.5 20.4902 11.0596 21.0498 11.75 21.0498H16.75C17.4404 21.0498 18 20.4902 18 19.7998V14.7998C18 14.1094 17.4404 13.5498 16.75 13.5498H11.75Z" :fill="color"/>
    <path d="M12 11.75C12 10.2312 13.2312 9 14.75 9H19.75C21.2688 9 22.5 10.2312 22.5 11.75V16.75C22.5 18.2688 21.2688 19.5 19.75 19.5H19V18H19.75C20.4404 18 21 17.4404 21 16.75V11.75C21 11.0596 20.4404 10.5 19.75 10.5H14.75C14.0596 10.5 13.5 11.0596 13.5 11.75V13H12V11.75Z" :fill="color"/>
  </svg>
</template>
  
  
<script>
  export default {
      name: 'Copy',
      props: {
          size: {
              type: String,
              default: '32'
          },
          color: {
              type: String,
              default: '#A1A8B8'
          },
          value: {
            type: String,
            require: true,
          },
          circleCx: {
              type: String,
              default: '16'
          },
          circleCy: {
              type: String,
              default: '16'
          },
          circleR: {
              type: String,
              default: '16'
          },
          cicleHoverFill: {
              type: String,
              default: '#F4F7FB'
          },
          ciclePressedFill: {
            type: String,
            default: '#DFE2EB'
          }
      },
      data() {
        return {
          mouse: false,
          pressed: false,
        }
      },
      methods: {
        async copy() {
          await navigator.clipboard.writeText(this.value)
          this.$notify({
              title: 'Copiado para transferência com sucesso!.',
              message: '',
              type: 'success',
              duration: 3000,
              offset: 100,
              showClose: false
          });
          setTimeout(() => this.pressed = false, 3000)
        }
      }
  }
</script>